import { render, staticRenderFns } from "./stepDeliveryChange.vue?vue&type=template&id=07b02d18&scoped=true&"
import script from "./stepDeliveryChange.vue?vue&type=script&lang=ts&"
export * from "./stepDeliveryChange.vue?vue&type=script&lang=ts&"
import style0 from "./stepDeliveryChange.vue?vue&type=style&index=0&id=07b02d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b02d18",
  null
  
)

export default component.exports